import { n as f } from "./Logger-CmiOOsKC.js";
import { Matrix as a, Quaternion as s } from "@babylonjs/core/Maths/math.vector.js";
function Q(t) {
  t.rotationQuaternion || (t.rotationQuaternion = s.FromEulerVector(t.rotation));
}
function v(t, i) {
  t && (t.position.setAll(0), t.rotationQuaternion ? t.rotationQuaternion.set(0, 0, 0, 1) : t.rotation && t.rotation.setAll(0), t.scaling.setAll(1), i && f.debug(`${i} Reset transform to identity for ${t.name}`));
}
var r = new a(), l = s.Identity(), e = 1e-6;
function y(t, i) {
  const n = Math.abs(i.y / i.x), o = Math.abs(i.z / i.x), u = Math.abs(n - 1) < e && Math.abs(o - 1) < e;
  (t.rotationQuaternion?.equals(l) ?? !0) || i.x === 0 || n === 0 || o === 0 || u ? a.IdentityToRef(r) : a.ScalingToRef(1, n, o, r), t.getPivotMatrix().equals(r) || t.setPivotMatrix(r);
}
export {
  y as n,
  v as r,
  Q as t
};

//# sourceMappingURL=TransformUtils-Bd2LIBHs.js.map